"use client";

import {
  Modal,
  Button,
  Text,
  CloseIcon,
  ExclamationCircleIcon,
} from "@treebo-noss/superhero-design-system";

interface BookingNotFoundModalProps {
  isOpen: boolean;
  onClose: () => void;
  contactInfo?: string;
}

export const BookingNotFoundModal = ({
  isOpen,
  onClose,
  contactInfo,
}: BookingNotFoundModalProps) => {
  if (!isOpen) return null;

  const contactLabel = contactInfo
    ? contactInfo.includes("@")
      ? "this email"
      : "this number"
    : "this account";

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      placement="bottom"
      radius="lg"
      contentClassName="w-full max-w-[450px] mx-auto"
    >
      <div className="flex flex-col pb-4">
        <div className="flex items-center justify-between px-4 pt-4 pb-4.5">
          <div className="flex items-center gap-2">
            <ExclamationCircleIcon className="text-warning-400" />
            <Text size="m" weight="semibold" className="text-neutral-700">
              Booking Not Found
            </Text>
          </div>
          <Button variant="link" className="p-0! w-6 h-6" onClick={onClose}>
            <CloseIcon className="text-neutral-600 w-6 h-6" />
          </Button>
        </div>
        <div className="border-t border-neutral-400" />
        <Text size="s" weight="normal" className="text-neutral-700 p-4 !pb-6">
          {contactInfo ? (
            <>
              We could not find a booking for{" "}
              <Text
                as="span"
                size="s"
                weight="semibold"
                className="text-neutral-700"
              >
                {contactInfo}
              </Text>
              .
            </>
          ) : (
            "We could not find any bookings linked to your account."
          )}{" "}
          Please ask your booker or the hotel front desk to add {contactLabel}{" "}
          for access.
        </Text>
        <Button onClick={onClose} className="mx-4" size="large">
          GOT IT
        </Button>
      </div>
    </Modal>
  );
};
